import { idtype } from "querypieces";

export default `
  ...on pageBuilder_programMap_BlockType {
    ${idtype}
  }
`;
